export default __webpack_public_path__ + "static/media/orderplaced.a8d63c3a.png";